import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle, faPlus, faCalendar, faFilter, faSun, faMap, faCircleDot, faStopwatch, faChair, faUsers, faCircleXmark, faFilePen, faRectangleXmark, faEnvelope, faWheelchairMove, faBaby, faBell, faReply, faSearch, faSquareCheck, faEye, faPhone, faCircleCheck, faGear, faLock } from "@fortawesome/free-solid-svg-icons";
import { Row, Col, Card, Modal, Button, ModalBody } from "react-bootstrap";
import styled from "styled-components";
import { postReservationAccept, updateReservationStatus, changeTableNumber, sendTableReadyMessage } from "../actions/restaurantActions";
import { fetchCancelReservation, checkCancelAction, updateReservation, ResetReservation } from "../actions/reservationsActions";
import moment from "moment-timezone";
import CompareChanges from "./CompareChanges";
import { getReservationStatusTranslation, cancelledDidNotAttendStatuses, getReservationStatusAbreviationTranslation, getReservationStatusColors, acceptedStatuses, pendingStatuses } from "./ReservationStatus";
import StatusDropdown from "./StatusDropdown";
import { ConfirmationModal } from "./DefaultImports";
const StyledReservationStatusBox = styled.div`
  display: flex;
  width: 300px;
  height: 70px;
  border-radius: 5px;
  margin-bottom: 10px;
  margin-right: 10px;
  position: absolute;
  right: 0px;
  bottom: 0;
`;
const TopBox = styled.div`
  position: absolute;
  display: flex;
  flex-wrap: wrap;
  justify-content: end;
  font-size: 17px;
  width: 100px;
  height: 60px;
  font-weight: bold;
  right: 0;
  bottom: 0;
  color: ${props => props.status === "cancelled" || props.status === "cancelled_customer" || props.status === "cancelled_restaurant" || props.status === "no_show" ? "#e8733c" : props.status === "Pending_from_customer_Warning" ? "#d6a7c1" : props.status === "edited" ? "#7e538a" : props.status === "waiting_list" ? "#7e538a" : props.status === "pending_restaurant" ? "#cacf44" : props.status === "pending_customer" ? "#959657" : props.status === "late" ? "#ebb052" : "#58c49f"};

  @media (max-width: 768px) {
    font-size: 18px;
    height: 90px;
  }
`;
const TextButtomBox = styled.div`
  width: 240px;
  height: 70px;
  left: 0;
  bottom: 0;
  position: absolute;
  display: flex;
  flex-wrap: wrap;
  justify-content: end;
  align-items: center;
`;
const TittleWrapper = styled.div`
  width: 100%;
  height: 30px;
  position: relative;
  align-items: center;
  text-align: center;
  display: flex;
  justify-content: flex-end;
  color: ${props => props.color};
  font-size: clamp(10px, 2.5vw, 16px); /* ⬅️ Responsive but max 14px */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 768px) {
    font-size: clamp(
      10px,
      3.5vw,
      16px
    ); // even more responsive on small screens
  }
`;
const ButtonsWrapper = styled.div`
  width: 100%;
  height: 30px;
  display: flex;
  justify-content: end;
`;
const LeftButton = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: auto;
  height: 100%;
  padding: 0px 3px 0px 3px;
  border-radius: 5px;
  background-color: #faf6e9;
  color: #ee754c;
  z-index: 1;
  cursor: pointer;
  font-size: 14px;
  &:hover {
    background-color: #faf6e9;
  }
`;
const RightButton = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  width: auto;
  padding: 0px 3px 0px 3px;
  height: 100%;
  background-color: #ee754c;
  color: #faf6e9;
  margin-left: 10px;
  border-radius: 5px;
  z-index: 1;
  white-space: nowrap;

  cursor: pointer;
  font-size: 14px;
  &:hover {
    background-color: rgb(241, 137, 102);
  }
`;
const FullButton = styled.div`
  font-size: 12px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 30px;
  background-color: #99b0ad;
  color: #faf6e9;
  z-index: 1;
  cursor: pointer;
  border-radius: 6px;
  &:hover {
    background-color: rgb(174, 194, 191);
  }
`;
const Circle = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #99b0ad;
  color: #faf6e9;
  cursor: pointer;
  z-index: 4;
  margin-left: 10px;
  position: absolute;
  right: 0;
  bottom: 0;
  &:hover {
    background-color: #ededed;
  }
  @media (max-width: 768px) {
  }
`;
const NumberBoxes = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  border: 1px solid gray;
  border-radius: 4px;
  background-color: white;
  color: black;
  margin: 5px;
  cursor: pointer;
  &:hover {
    background-color: #ededed;
  }
`;
const DropdownTrigger = styled.div`
  width: 100%;
  height: 30px;
  position: relative;
  align-items: center;
  text-align: center;
  display: flex;
  justify-content: flex-end;
  color: ${props => props.color};
  font-size: clamp(10px, 2.5vw, 16px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;

  @media (max-width: 768px) {
    font-size: clamp(10px, 3.5vw, 16px);
  }
`;
const PortalDropdown = styled.div`
  position: absolute;
  background-color: white;
  border: 1px solid #ccc;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  min-width: 180px;
  z-index: 3000;
  padding: 4px 0;
`;
const DropdownItem = styled.div`
  padding: 8px 12px;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background-color: #f0f0f0;
  }
`;
function ReservationStatusBox({
  reservation,
  index,
  statusBoxRef = null,
  reservations,
  setTokens = false,
  isShowCustomerInfo
}) {
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [numbers, setNumbers] = useState(Array.from({
    length: 101
  }, (_, index) => index));
  const [showAcceptModal, setShowAcceptModal] = useState(false);
  const [showSendTableReadyMessageModal, setShowSendTableReadyMessageModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showAttendanceOptions, setShowAttendanceOptions] = useState(false);
  const [showAttendanceModal, setShowAttendanceModal] = useState(false);
  const [showNotAttendanceModal, setShowNotAttendanceModal] = useState(false);
  const [showModalRestoreReservation, setShowModalRestoreReservation] = useState(false);
  const [showChangeTablesModal, setShowChangeTablesModal] = useState(false);
  const [rejectEdition, setRejectEdition] = useState(false);
  const [reservationBeforeEdition, setReservationBeforeEdition] = useState(null);
  const [notify_customer, setNotify_customer] = useState(true);
  const [reservationToChangeToken, setReservationToChangeToken] = useState("");
  const [reservationToChangeName, setReservationToChangeName] = useState("");
  const [reservationToChangeNumber, setReservationToChangeNumber] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [actionError, setActionError] = useState("");
  const crudManagerPermissions = useSelector(state => state.crudManager);
  const {
    managerInfo
  } = crudManagerPermissions;
  useEffect(() => {
    if (reservation && typeof reservation === "object" && Array.isArray(reservation.history) && typeof reservation.restore_version_id !== "undefined") {
      const filteredHistoryItem = reservation.history.find(item => item && typeof item === "object" && item.history_id === reservation.restore_version_id);
      setReservationBeforeEdition(filteredHistoryItem || null);
    } else {
      setReservationBeforeEdition(null);
    }
  }, [reservation]);
  const restaurantTimeZone = useSelector(state => state.reservationBlockedWeekDays.restaurantTimeZone);
  useEffect(() => {
    if (restaurantTimeZone) {
      const currentTime = moment.tz(restaurantTimeZone.timezone);
      const currentTimeToShowAttendance = currentTime.clone().add(24, "hours");
      const reservationDateTime = moment.tz(`${reservation.date} ${reservation.time}`, "YYYY-MM-DD HH:mm", restaurantTimeZone.timezone);
      if (reservationDateTime.isBefore(currentTimeToShowAttendance)) {
        setShowAttendanceOptions(true);
      }
    }
  }, [restaurantTimeZone, reservation, index]);
  const handleCloseModal = () => {
    setShowModal(false);
  };
  const runReservationAction = async (action, onSuccess) => {
    if (isSubmitting) return false;
    setIsSubmitting(true);
    setActionError("");
    try {
      const result = await dispatch(action);
      if (result?.ok) {
        if (onSuccess) onSuccess();
        return true;
      }
      if (!result?.busy) {
        setActionError(
          result?.message ||
            t("ui.i18nFinalCleanup.genericTryAgainError", {
              defaultValue: "Ocorreu um erro. Tenta novamente.",
            }),
        );
      }
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };
  const runTableAction = async (action, onSuccess) => {
    if (isSubmitting) return false;
    setIsSubmitting(true);
    setActionError("");
    try {
      await dispatch(action);
      if (onSuccess) onSuccess();
      return true;
    } catch (error) {
      setActionError(
        error?.message ||
          t("ui.i18nFinalCleanup.tableChangeError", {
            defaultValue: "Não foi possível alterar a mesa.",
          }),
      );
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleChangeTable = async (number, isNotAllowed, reservation_name, reservation_token) => {
    if (!isNotAllowed) {
      const succeeded = await runTableAction(
        changeTableNumber(reservation.token, number),
        () => setShowModal(false),
      );
      if (succeeded && reservation.status === "waiting_list") {
        setShowSendTableReadyMessageModal(true);
      }
    } else {
      setReservationToChangeNumber(number);
      setReservationToChangeToken(reservation_token);
      setReservationToChangeName(reservation_name);
      setShowChangeTablesModal(true);
    }
  };
  const sendTheTableReadyMessage = () => {
    dispatch(sendTableReadyMessage(reservation.token));
    setShowSendTableReadyMessageModal(false);
  };
  const changeTablesWithOtherReservation = async () => {
    const succeeded = await runTableAction(
      changeTableNumber(
        reservation.token,
        reservationToChangeNumber,
        reservationToChangeToken,
      ),
      () => {
        setShowChangeTablesModal(false);
        setShowModal(false);
      },
    );
    if (succeeded && reservation.status === "waiting_list") {
      setShowSendTableReadyMessageModal(true);
    }
  };
  const handleShowAcceptModal = str => {
    setActionError("");
    if (str === "rejectEdition") {
      setRejectEdition(true);
    } else {
      setRejectEdition(false);
    }
    setShowAcceptModal(true);
  };
  const handleCloseAcceptModal = () => {
    if (!isSubmitting) setShowAcceptModal(false);
  };
  const handleShowCancelModal = str => {
    setActionError("");
    if (str === "rejectEdition") {
      setRejectEdition(true);
    } else {
      setRejectEdition(false);
    }
    setShowCancelModal(true);
  };
  const handleCloseCancelModal = () => {
    if (!isSubmitting) setShowCancelModal(false);
  };
  const clearTokenAfterSuccess = () => {
    if (setTokens !== false) setTokens("");
  };
  const handleAccept = async () => {
    await runReservationAction(
      postReservationAccept(
        reservation.token,
        false,
        rejectEdition,
        notify_customer,
      ),
      () => {
        setShowAcceptModal(false);
        clearTokenAfterSuccess();
      },
    );
  };
  const handleCancel = async () => {
    await runReservationAction(
      fetchCancelReservation(reservation.id, false, false, rejectEdition),
      () => {
        setShowCancelModal(false);
        clearTokenAfterSuccess();
      },
    );
  };
  const handleCheckCancel = token => {
    if (isSubmitting) return;
    dispatch(checkCancelAction(token));
    clearTokenAfterSuccess();
  };
  const handleAttended = async () => {
    await runReservationAction(
      updateReservationStatus(reservation.id, "attended"),
      () => {
        setShowAttendanceModal(false);
        clearTokenAfterSuccess();
      },
    );
  };
  const handleNotAttended = async () => {
    await runReservationAction(
      updateReservationStatus(reservation.id, "no_show"),
      () => {
        setShowNotAttendanceModal(false);
        clearTokenAfterSuccess();
      },
    );
  };
  const handleShowAttendanceModal = () => {
    setActionError("");
    setShowAttendanceModal(true);
  };
  const handleHideAttendanceModal = () => {
    if (!isSubmitting) setShowAttendanceModal(false);
  };
  const handleShowDidNotAttendanceModal = () => {
    setActionError("");
    setShowNotAttendanceModal(true);
  };
  const handleHideDidNotAttendanceModal = () => {
    if (!isSubmitting) setShowNotAttendanceModal(false);
  };
  const handleShowModalRestoreReservation = () => {
    setActionError("");
    setShowModalRestoreReservation(true);
  };
  const handleHideModalRestoreReservation = () => {
    if (!isSubmitting) setShowModalRestoreReservation(false);
  };
  const handleRestoreCancel = async () => {
    await runReservationAction(
      updateReservationStatus(reservation.id, "waiting_list"),
      () => {
        setShowModalRestoreReservation(false);
        clearTokenAfterSuccess();
      },
    );
  };
  const checkOverlap = (newStartTime, newEndTime, existingStartTime, existingEndTime) => {
    return newStartTime <= existingEndTime && newEndTime >= existingStartTime;
  };
  const markNotAllowedTables = () => {
    if (reservations) {
      const baseDate = new Date().toISOString().substring(0, 10);
      const existingStartTime = new Date(`${baseDate}T${reservation.time}:00`);
      const existingEndTime = new Date(`${baseDate}T${reservation.estimatedtime}:00`);
      const activeReservations = reservations.filter(reservation => !cancelledDidNotAttendStatuses.includes(reservation.status));
      const markedNumbers = numbers.map(number => {
        let reservation_name;
        let reservation_token;
        const isNotAllowed = activeReservations.some(reservation => {
          if (reservation.table_number === number.toString()) {
            const newStartTime = new Date(`${baseDate}T${reservation.time}:00`);
            const newEndTime = new Date(`${baseDate}T${reservation.estimatedtime}:00`);
            reservation_name = reservation.full_name;
            reservation_token = reservation.token;
            return checkOverlap(newStartTime, newEndTime, existingStartTime, existingEndTime);
          }
          return false;
        });
        return {
          number,
          isNotAllowed,
          reservation_name,
          reservation_token
        };
      });
      return markedNumbers;
    }
    return [];
  };
  useEffect(() => {
    if (reservations) {
      markNotAllowedTables();
    }
  }, [reservations, reservation]);
  const patchReservationStatus = async (reservation_id, newStatus, options = {}) => {
    console.log("PARENT patchReservationStatus options:", options);
    return runReservationAction(updateReservationStatus(reservation_id, newStatus, options));
  };
  return <>
      <StyledReservationStatusBox>
        {reservations ? <Circle onClick={() => {
        if (!cancelledDidNotAttendStatuses.includes(reservation.status)) {
          setShowModal(!showModal);
        }
      }}>
            {reservation.table_number && reservation.table_number !== "null" ? reservation.table_number : ""}
          </Circle> : null}

        {!isShowCustomerInfo ? <TextButtomBox>
            <StatusDropdown reservation={reservation} allowedStatuses={["accepted", "pending_restaurant", "late", "waiting_list", "cancelled_restaurant", "cancelled_customer"]} getStatusColor={getReservationStatusColors} getStatusLabel={getReservationStatusAbreviationTranslation} onSelectStatus={(status, options = {}) => {
          console.log("options a: ", options);
          patchReservationStatus(reservation.id, status, options);
        }} />

            {pendingStatuses.includes(reservation.status) && <ButtonsWrapper>
                <LeftButton onClick={() => handleShowAcceptModal()}>{t("ui.components.reservationStatusBox.aceitar")}</LeftButton>
                <RightButton onClick={() => handleShowCancelModal()}>{t("ui.components.reservationStatusBox.rejeitar")}</RightButton>
              </ButtonsWrapper>}

            {managerInfo && !managerInfo.change_status ? null : reservation.status === "edited" && <ButtonsWrapper>
                    <LeftButton onClick={() => handleShowAcceptModal("rejectEdition")}>{t("ui.components.reservationStatusBox.aceitar2")}</LeftButton>
                    <RightButton onClick={() => handleShowCancelModal("rejectEdition")}>{t("ui.components.reservationStatusBox.rejeitar2")}</RightButton>
                  </ButtonsWrapper>}

            {managerInfo && !managerInfo.change_status ? null : acceptedStatuses.includes(reservation.status) && showAttendanceOptions ? <ButtonsWrapper>
                <LeftButton onClick={handleShowAttendanceModal}>{t("ui.components.reservationStatusBox.compareceu")}</LeftButton>
                <RightButton onClick={handleShowDidNotAttendanceModal}>{t("ui.components.reservationStatusBox.naoCompareceu")}</RightButton>
              </ButtonsWrapper> : null}

            {managerInfo && !managerInfo.change_status ? null : reservation.cancelled_warning === true ? <FullButton onClick={() => handleCheckCancel(reservation.token)}>
                <FontAwesomeIcon size="xl" icon={faEye} style={{
            color: "#ffffff",
            marginLeft: "10px"
          }} />
              </FullButton> : reservation.status === "attended" || reservation.status === "no_show" || reservation.status === "Cancelled" || reservation.status === "cancelled_customer" || reservation.status === "cancelled_restaurant" ? <FullButton status={reservation.status} onClick={handleShowModalRestoreReservation}>
                <FontAwesomeIcon size="xl" icon={faReply} style={{
            color: "#ffffff",
            marginLeft: "10px"
          }} />
              </FullButton> : null}
          </TextButtomBox> : null}
      </StyledReservationStatusBox>

      <Modal show={showModal} onHide={handleCloseModal}>
        <div ref={statusBoxRef}>
          <Modal.Header closeButton>
            <Modal.Title>{t("ui.components.reservationStatusBox.nomearMesa")}</Modal.Title>
          </Modal.Header>

          <Modal.Body style={{
          maxHeight: "200px",
          overflow: "auto",
          display: "flex",
          flexWrap: "wrap"
        }}>
            <NumberBoxes onClick={() => handleChangeTable(null)}></NumberBoxes>

            {reservations && markNotAllowedTables().map(({
            number,
            isNotAllowed,
            reservation_name,
            reservation_token
          }) => {
            return <NumberBoxes key={number} onClick={() => handleChangeTable(number, isNotAllowed, reservation_name, reservation_token)} style={{
              backgroundColor: parseInt(number) === parseInt(reservation.table_number) ? "#9FBBC1" : isNotAllowed ? "#deb949" : "#ffffff"
            }}>
                      {number}
                    </NumberBoxes>;
          })}
          </Modal.Body>

          <Modal.Footer></Modal.Footer>
        </div>
      </Modal>

      <Modal show={showAcceptModal} onHide={() => { if (!isSubmitting) handleCloseAcceptModal(); }}>
        <div ref={statusBoxRef}>
          <Modal.Header closeButton>
            <Modal.Title>
              {rejectEdition ? t("ui.i18nCleanup2.aceitarAlteracao") : t("ui.i18nCleanup2.aceitarReserva")}
            </Modal.Title>
          </Modal.Header>

          {rejectEdition && reservation && reservationBeforeEdition && <Modal.Body>
              <CompareChanges before={reservationBeforeEdition} after={reservation} />
            </Modal.Body>}

          <label style={{
          display: "flex",
          alignItems: "center",
          gap: "5px",
          marginLeft: "10px"
        }}>
            <input type="checkbox" checked={notify_customer} onChange={e => setNotify_customer(e.target.checked)} />{t("ui.components.reservationStatusBox.enviarUmaNotificacaoAoCliente")}</label>

          <Modal.Footer>
            {actionError && <span style={{ color: "#D94B4B", marginRight: "auto", fontSize: "13px" }}>{actionError}</span>}
            <Button variant="success" disabled={isSubmitting} onClick={handleAccept}>{isSubmitting ? t("ui.i18nFinalCleanup.processing") : t("ui.components.reservationStatusBox.sim")}</Button>
            <Button variant="danger" disabled={isSubmitting} onClick={handleCloseAcceptModal}>{t("ui.components.reservationStatusBox.nao")}</Button>
          </Modal.Footer>
        </div>
      </Modal>

      <Modal show={showCancelModal} onHide={() => { if (!isSubmitting) handleCloseCancelModal(); }}>
        <div ref={statusBoxRef}>
          <Modal.Header closeButton>
            <Modal.Title>
              {rejectEdition ? t("ui.i18nCleanup2.rejeitarAlteracao") : t("ui.i18nCleanup2.rejeitarReserva")}
            </Modal.Title>
          </Modal.Header>

          {rejectEdition && reservation && reservationBeforeEdition && <Modal.Body>
              <CompareChanges before={reservationBeforeEdition} after={reservation} />
            </Modal.Body>}

          <Modal.Footer>
            {actionError && <span style={{ color: "#D94B4B", marginRight: "auto", fontSize: "13px" }}>{actionError}</span>}
            <Button variant="success" disabled={isSubmitting} onClick={handleCancel}>{isSubmitting ? t("ui.i18nFinalCleanup.processing") : t("ui.components.reservationStatusBox.sim2")}</Button>
            <Button variant="danger" disabled={isSubmitting} onClick={handleCloseCancelModal}>{t("ui.components.reservationStatusBox.nao2")}</Button>
          </Modal.Footer>
        </div>
      </Modal>

      <Modal show={showAttendanceModal} onHide={handleHideAttendanceModal}>
        <div ref={statusBoxRef}>
          <Modal.Header closeButton>
            <Modal.Title>{t("ui.components.reservationStatusBox.confirmarComparencia")}</Modal.Title>
          </Modal.Header>

          <Modal.Footer>
            {actionError && <span style={{ color: "#D94B4B", marginRight: "auto", fontSize: "13px" }}>{actionError}</span>}
            <Button variant="success" disabled={isSubmitting} onClick={handleAttended}>{isSubmitting ? t("ui.i18nFinalCleanup.processing") : t("ui.components.reservationStatusBox.confirmar")}</Button>
          </Modal.Footer>
        </div>
      </Modal>

      <Modal show={showChangeTablesModal} onHide={() => { if (!isSubmitting) setShowChangeTablesModal(false); }}>
        <div ref={statusBoxRef}>
          <Modal.Header closeButton>
            <Modal.Title>{t("ui.components.reservationStatusBox.trocarMesa")}<span style={{
              fontWeight: "bold"
            }}>
                {" "}
                {reservation.table_number}{" "}
              </span>{t("ui.components.reservationStatusBox.comMesa")}<span style={{
              fontWeight: "bold"
            }}>
                {" "}
                {reservationToChangeNumber}{" "}
              </span>{t("ui.components.reservationStatusBox.daReserva")}<span style={{
              fontWeight: "bold"
            }}>
                {" "}
                {reservationToChangeName}{" "}
              </span>
            </Modal.Title>
          </Modal.Header>

          <Modal.Footer>
            {actionError && <span style={{ color: "#D94B4B", marginRight: "auto", fontSize: "13px" }}>{actionError}</span>}
            <Button variant="success" disabled={isSubmitting} onClick={changeTablesWithOtherReservation}>{isSubmitting ? t("ui.i18nFinalCleanup.processing") : t("ui.components.reservationStatusBox.confirmar2")}</Button>
          </Modal.Footer>
        </div>
      </Modal>

      <Modal show={showNotAttendanceModal} onHide={handleHideDidNotAttendanceModal}>
        <div ref={statusBoxRef}>
          <Modal.Header closeButton>
            <Modal.Title>{t("ui.components.reservationStatusBox.confirmarNaoComparencia")}</Modal.Title>
          </Modal.Header>

          <Modal.Footer>
            {actionError && <span style={{ color: "#D94B4B", marginRight: "auto", fontSize: "13px" }}>{actionError}</span>}
            <Button variant="success" disabled={isSubmitting} onClick={handleNotAttended}>{isSubmitting ? t("ui.i18nFinalCleanup.processing") : t("ui.components.reservationStatusBox.confirmar3")}</Button>
          </Modal.Footer>
        </div>
      </Modal>

      <Modal show={showModalRestoreReservation} onHide={handleHideModalRestoreReservation}>
        <div ref={statusBoxRef}>
          <Modal.Header closeButton>
            <Modal.Title>{t("ui.components.reservationStatusBox.restaurarReserva")}</Modal.Title>
          </Modal.Header>

          <Modal.Footer>
            {actionError && <span style={{ color: "#D94B4B", marginRight: "auto", fontSize: "13px" }}>{actionError}</span>}
            <Button variant="success" disabled={isSubmitting} onClick={handleRestoreCancel}>{isSubmitting ? t("ui.i18nFinalCleanup.processing") : t("ui.components.reservationStatusBox.sim3")}</Button>
            <Button variant="danger" disabled={isSubmitting} onClick={() => setShowModalRestoreReservation(false)}>{t("ui.components.reservationStatusBox.nao3")}</Button>
          </Modal.Footer>
        </div>
      </Modal>

      <Modal show={showSendTableReadyMessageModal} onHide={() => setShowSendTableReadyMessageModal(!showSendTableReadyMessageModal)}>
        <div ref={statusBoxRef}>
          <Modal.Header closeButton>
            <Modal.Title>{t("ui.components.reservationStatusBox.enviarMensagem")}</Modal.Title>
          </Modal.Header>

          <Modal.Body>{t("ui.components.reservationStatusBox.avisarClienteQueASuaMesa")}</Modal.Body>

          <Modal.Footer>
            <Button variant="success" onClick={sendTheTableReadyMessage}>{t("ui.components.reservationStatusBox.enviar")}</Button>
            <Button variant="danger" onClick={() => setShowSendTableReadyMessageModal(!showSendTableReadyMessageModal)}>{t("ui.components.reservationStatusBox.naoEnviar")}</Button>
          </Modal.Footer>
        </div>
      </Modal>
    </>;
}
export default ReservationStatusBox;
